(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compre-junto-inferior"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {

    const compreJuntoSection = document.querySelector('.compre-junto-inferior-section');

    if (!compreJuntoSection) {
      return;
    }

    const mainProductElementInferior = document.querySelector('.main-product-inferior');
    const items_inferior = document.querySelectorAll('.compre-junto-inferior-item');
    const totalPriceElementInferior = document.getElementById('total-price-inferior');
    const addButtonInferior = document.querySelector('.compre-junto-inferior-btn');

    let mainVariantIdInferior;
    let mainVariantPriceInferior;

  function updateTotalInferior() {
    let total = 0;
    let totalCompare = 0;
    let selectedItemsInferior = [];
    
    items_inferior.forEach(item => {
      if (item.getAttribute('data-selected') === 'true') {
        total += parseFloat(item.getAttribute('data-price'));
        
        const comparePrice = parseFloat(item.getAttribute('data-compare-price') || item.getAttribute('data-price'));
        totalCompare += comparePrice;
        
        selectedItemsInferior.push(item.getAttribute('data-id'));
      }
    });
    
    const totalComparePriceElement = document.getElementById('total-compare-price-inferior');
    if (totalComparePriceElement) {
      if (totalCompare <= total) {
         totalComparePriceElement.parentElement.style.display = 'none';
      } else {
         totalComparePriceElement.parentElement.style.display = 'block';
         totalComparePriceElement.textContent = totalCompare.toLocaleString('pt-BR', { 
            style: 'currency', 
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
         });
      }
    }
    
    totalPriceElementInferior.textContent = total.toLocaleString('pt-BR', { 
      style: 'currency', 
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    addButtonInferior.disabled = selectedItemsInferior.length < 1;
  }

function updateMainProductInCompreJuntoInferior(variantId) {
  const mainSelect = mainProductElementInferior.querySelector('.compre-junto-inferior-select-variant');
  if (!mainSelect) {
    console.warn("Seletor de variante principal do Compre Junto Inferior não encontrado.");
    return;
  }

  const optionToSelect = Array.from(mainSelect.options).find(option => parseInt(option.value) === variantId);
  
  if (optionToSelect) {
    mainSelect.value = variantId;
    const newCurrentPrice = parseFloat(optionToSelect.getAttribute('data-current-price'));
    const newComparePrice = parseFloat(optionToSelect.getAttribute('data-compare-price'));
    const newImage = optionToSelect.getAttribute('data-image');

    mainVariantIdInferior = parseInt(optionToSelect.value);
    mainVariantPriceInferior = newCurrentPrice;

    mainProductElementInferior.setAttribute('data-id', mainVariantIdInferior);
    mainProductElementInferior.setAttribute('data-price', newCurrentPrice);
    mainProductElementInferior.setAttribute('data-compare-price', newComparePrice);

    const imgElement = mainProductElementInferior.querySelector('.compre-junto-inferior-item-image-display');
    if (imgElement) {
      imgElement.src = newImage;
    }
    updateTotalInferior();
  } else {
    console.warn(`Variante ${variantId} não encontrada no select do Compre Junto Inferior para o produto principal. Mantendo estado atual.`);
  }
}

items_inferior.forEach(item => {
  if (item.classList.contains('main-product-inferior')) {
    item.setAttribute('data-selected', 'true');
    const checkboxCircle = item.querySelector('.compre-junto-inferior-checkbox-circle');
    if (checkboxCircle) checkboxCircle.classList.add('checked');
    return;
  }

  const selectionBox = item.querySelector('.compre-junto-inferior-selection-box');
  const checkboxCircle = item.querySelector('.compre-junto-inferior-checkbox-circle');

  if (selectionBox && checkboxCircle) {
    const isUnavailable = selectionBox.getAttribute('data-disabled') === 'true';

    if (isUnavailable) {
      item.setAttribute('data-selected', 'false');
      checkboxCircle.classList.remove('checked');
      item.classList.add('compre-junto-inferior-item-unavailable');
    } else {
      selectionBox.addEventListener('click', function (e) {
        e.stopPropagation();
        const isSelected = item.getAttribute('data-selected') === 'true';
        item.setAttribute('data-selected', !isSelected ? 'true' : 'false');
        checkboxCircle.classList.toggle('checked', !isSelected);
        updateTotalInferior();
      });
    }
  }
});

    document.querySelectorAll('.compre-junto-inferior-select-variant').forEach(function (selectElement) {
      const parentItem = selectElement.closest('.compre-junto-inferior-item');
      if (!parentItem) return;

      if (!parentItem.classList.contains('main-product-inferior')) {
          const initialSelectedOption = selectElement.options[selectElement.selectedIndex];
          const initialCurrentPrice = parseFloat(initialSelectedOption.getAttribute('data-current-price'));
          const initialComparePrice = parseFloat(initialSelectedOption.getAttribute('data-compare-price'));
          const initialImage = initialSelectedOption.getAttribute('data-image');

          parentItem.setAttribute('data-id', initialSelectedOption.value);
          parentItem.setAttribute('data-price', initialCurrentPrice);

          const imgElement = parentItem.querySelector('.compre-junto-inferior-item-image-display');
          if (imgElement) {
            imgElement.src = initialImage;
          }
      }

      selectElement.addEventListener('change', function () {
        const selectedOption = this.options[this.selectedIndex];
        const newVariantId = parseInt(selectedOption.value);
        const newCurrentPrice = parseFloat(selectedOption.getAttribute('data-current-price'));
        const newComparePrice = parseFloat(selectedOption.getAttribute('data-compare-price'));
        const newImage = selectedOption.getAttribute('data-image');

        if (parentItem.classList.contains('main-product-inferior')) {
          updateMainProductInCompreJuntoInferior(newVariantId);
        } else {
          parentItem.setAttribute('data-id', newVariantId);
          parentItem.setAttribute('data-price', newCurrentPrice);
          parentItem.setAttribute('data-compare-price', newComparePrice);

          const imgElement = parentItem.querySelector('.compre-junto-inferior-item-image-display');
          if (imgElement) {
            imgElement.src = newImage;
          }
          updateTotalInferior();
        }
      });
    });

 addButtonInferior.addEventListener('click', function () {
   addButtonInferior.disabled = true;
   const originalButtonText = addButtonInferior.textContent;
   addButtonInferior.textContent = 'Adicionando...';
 
   const itemsToAddInferior = [];
   items_inferior.forEach(item => {
  if (item.getAttribute('data-selected') === 'true') {
    itemsToAddInferior.push({
   id: parseInt(item.getAttribute('data-id')),
   quantity: 1
    });
  }
   });

   fetch('/cart/add.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ items: itemsToAddInferior })
   })
   .then(response => {
  if (!response.ok) {
    return response.json().then(error => { throw new Error(error.description || 'Erro desconhecido'); });
  }
  return response.json();
   })
   .then(cartData => {
  if (typeof window.updateCart === 'function') {
    window.updateCart();
  } else {
    console.warn('Função window.updateCart() não encontrada. Tentando fallback.');
    document.querySelector('[data-cart-sidebar]')?.click();
  }
 
  setTimeout(() => {
    addButtonInferior.textContent = originalButtonText;
    updateTotalInferior();
  }, 1500);
   })
   .catch((error) => {
  console.error('Erro ao adicionar itens ao carrinho:', error);
  addButtonInferior.textContent = 'Erro!';
  setTimeout(() => {
    addButtonInferior.textContent = originalButtonText;
    updateTotalInferior();
  }, 2500);
   });
 });
     
    function syncItemVisuals(item) {
      const select = item.querySelector('.compre-junto-inferior-select-variant');
      if (!select) return; 
    
      select.dispatchEvent(new Event('change'));
    }

    window.addEventListener('pageshow', function() {
      items_inferior.forEach(syncItemVisuals);
    });

    items_inferior.forEach(syncItemVisuals);

    updateTotalInferior();
  });
  } catch(e) { console.error(e); }
})();

})();
